import { render, staticRenderFns } from "./cfHouse.vue?vue&type=template&id=e67b237c&scoped=true"
import script from "./cfHouse.vue?vue&type=script&lang=js"
export * from "./cfHouse.vue?vue&type=script&lang=js"
import style0 from "./cfHouse.vue?vue&type=style&index=0&id=e67b237c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67b237c",
  null
  
)

export default component.exports